module.exports = __webpack_public_path__ + "media/src/images/safe_clipart-0e45138bcb233ebb3ffa408aff570767.svg";